/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { isError } from "@epic-mw/error-types";
import useSWRImmutable from "swr/immutable";

import { getApiPath } from "../utils";

export interface GeoRes {
	country?: string;
	countryName?: string;
	countryRegion?: string;
	countryRegionName?: string;
}

export const getGeo = async (): Promise<GeoRes> => {
	try {
		const response = await fetch(`${getApiPath()}/geo`);
		const json: GeoRes = await response.json();
		return json;
	} catch (err) {
		console.error("geo() failed to load", isError(err) && err.message);
		throw err;
	}
};

export const useGeo = (): {
	geo?: GeoRes;
	isLoading: boolean;
	error?: string;
} => {
	const { data, error } = useSWRImmutable("geo", getGeo, {
		errorRetryCount: 1,
	});

	return {
		geo: data,
		isLoading: !data && !error,
		error,
	};
};
